module.exports = __webpack_public_path__ + "static/Altero-Regular-187af05ee9a00eec0359351525a799b6.woff";